import { ActionIcon, Button, Flex, Menu, Table, Text } from '@mantine/core'
import classes from './AdminSettings.module.css'
import { IconDots } from '@tabler/icons-react'
import { useAppDispatch } from '@hooks/redux'
import { useEffect } from 'react'
import {
  clearHeaderInfo,
  setActiveSection,
  setHeaderInfo,
} from '@redux/site/siteSlice'

const MOCK_DATA = [
  {
    tag: 'SHC',
    description: 'Severe health condition',
  },
  {
    tag: 'STH',
    description: 'Student in temporary housing',
  },
  {
    tag: 'FC',
    description: 'Foster care',
  },
  {
    tag: 'NAC',
    description: 'Needs assessment complete',
  },
  {
    tag: 'VAX',
    description: 'Require vaccinations',
  },
]

export const ExclusiveTags = () => {
  const dispatch = useAppDispatch()

  useEffect(() => {
    dispatch(setActiveSection('Exclusive Tags'))
    dispatch(
      setHeaderInfo(
        'Only Administrators can create, edit, delete, or manage the use of exclusive tags.',
      ),
    )

    return () => {
      dispatch(clearHeaderInfo())
    }
  })

  const rows = MOCK_DATA.map((item) => (
    <Table.Tr key={item.tag}>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.tag}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>{item.description}</Table.Td>
      <Table.Td style={{ whiteSpace: 'pre' }}>
        <Menu>
          <Menu.Target>
            <ActionIcon variant="default" radius="xl" aria-label="Options">
              <IconDots style={{ width: '70%', height: '70%' }} stroke={1.5} />
            </ActionIcon>
          </Menu.Target>
          <Menu.Dropdown>
            <Menu.Item color="dark">Edit</Menu.Item>
            <Menu.Item color="red" onClick={() => {}}>
              Delete
            </Menu.Item>
          </Menu.Dropdown>
        </Menu>
      </Table.Td>
    </Table.Tr>
  ))

  return (
    <>
      <Flex justify="flex-end" p="xs">
        <Button>Create Exclusive Tag</Button>
      </Flex>
      <Table withRowBorders={false} verticalSpacing="xs">
        <Table.Thead>
          <Table.Tr className={classes.AdminSettings__thead}>
            <Table.Th key={`columns-1`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Tag
              </Text>
            </Table.Th>

            <Table.Th key={`columns-2`} style={{ whiteSpace: 'pre' }}>
              <Text size="xs" c="black">
                Description
              </Text>
            </Table.Th>

            <Table.Th>
              <Text size="xs">12 results</Text>
            </Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>{rows}</Table.Tbody>
      </Table>
    </>
  )
}
